import {
  AutocompleteInput,
  ReferenceInput,
} from "react-admin";
import MuiDatePickerInput from "../../common/MuiDatePickerInput";
import ProductCodeFilterInput from "../../sales/common/ProductCodeFilterInput";

const filterToQuery = (searchText) => ({ all: searchText });

const saleNetCardFilterList = (permissions) => {
  const defaultFilter = [
    <MuiDatePickerInput
      alwaysOn
      source="start_date"
      label="mine.label.start_date"
      variant="outlined"
      // maxDateSource="end_date"
    />,
    <MuiDatePickerInput
      alwaysOn
      source="end_date"
      label="mine.label.end_date"
      variant="outlined"
      // minDateSource="start_date"
    />,
    <ProductCodeFilterInput
      alwaysOn
      source="goods_code"
      variant="outlined"
      label="mine.label.goods_code"
    />,
    <ReferenceInput source="customer" reference="customers" alwaysOn resettable>
          <AutocompleteInput
            label="mine.label.customer"
            optionText="name"
            variant="outlined"
            filterToQuery={filterToQuery}
          />
        </ReferenceInput>,
    <ReferenceInput source="salesman" reference="salesmen" alwaysOn resettable>
          <AutocompleteInput
            optionText="name"
            variant="outlined"
            filterToQuery={filterToQuery}
          />
        </ReferenceInput>,
    <ReferenceInput alwaysOn source="quality_id" reference="qualities">
      <AutocompleteInput
        label="mine.label.quality"
        variant="outlined"
        fullWidth
        optionValue="id"
        optionText="name"
        filterToQuery={(searchText) => ({
          name: searchText,
        })}
      />
    </ReferenceInput>,
    <ReferenceInput alwaysOn source="size_id" reference="sizes">
      <AutocompleteInput
        label="mine.label.size"
        variant="outlined"
        fullWidth
        optionValue="id"
        optionText="name"
        filterToQuery={(searchText) => ({
          name: searchText,
        })}
      />
    </ReferenceInput>,
  ];
  if (permissions && permissions.update_company) {
    defaultFilter.splice(
      1,
      0,
      <ReferenceInput
        alwaysOn
        source="company_id"
        reference="companies"
        sort={{ field: "companies.alias", order: "ASC" }}
      >
        <AutocompleteInput
          resettable
          optionText="alias"
          variant="outlined"
          label="mine.label.depo"
        />
      </ReferenceInput>
    );
  }
  return defaultFilter;
};
export default saleNetCardFilterList;
